import { BrowserRouter } from 'react-router-dom';

// routes
import AllRoutes from '.';
import { ToastContainer } from 'react-toastify';

const Routes = () => {
    return (
        <BrowserRouter>
            <AllRoutes />
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </BrowserRouter>
    );
};

export default Routes;
